import { useDisclosure } from '@chakra-ui/react';
import { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

export default function Collapsible({ title, children }) {
  const {
    isOpen,
    onToggle
  } = useDisclosure()

  return (
    <div className="w-full">
      {/* Mobile View */}
      <div className="block md:hidden border rounded-lg bg-white shadow-sm overflow-hidden">
        <button
          onClick={onToggle}
          className="w-full flex justify-between items-center p-4 text-left text-sm font-medium text-gray-900 bg-gray-100 hover:bg-gray-200 focus:outline-none"
        >
          <span>{title}</span>
          {isOpen ? <FaChevronUp className="w-5 h-5" /> : <FaChevronDown className="w-5 h-5" />}
        </button>

        <div
          className={`transition-all duration-300 ease-in-out ${
            isOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
          } overflow-hidden px-4`}
        >
          {isOpen && <div>{children}</div>}
        </div>
      </div>

      {/* Desktop View */}
      <div className="hidden md:block">
        {children}
      </div>
    </div>
  );
}
